module.exports = __webpack_public_path__ + "static/media/web maintanance.67b9463e.svg";